import { SharedErrorObjectI } from "src/app/shared/models/shared/shared-error-object.interface";
import { StatsUpdateLogI } from "src/app/api/stats-update-log/stats-update-log.result.int";
import { StatsUpdateLogQueryI } from "src/app/api/stats-update-log/stats-update-log.query.int";
import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { spxCreateApiActions } from "@softpak/components/spx-redux";

export const StatsUpdateLogActions = createActionGroup({
  source: 'StatsUpdateLog',
  events: {
    ...spxCreateApiActions<StatsUpdateLogQueryI, StatsUpdateLogI, SharedErrorObjectI>(),
    Flush: emptyProps(),
    Queue: props<{ query: StatsUpdateLogQueryI }>(),
  },
});
